import React, { useState, useEffect } from 'react'
import { Link, useParams  } from "react-router-dom"
import './common.css'
import API_URL from '../common/Apiurl';
import SuccessMessage from '../common/Message';

function Editjob(){
    const apiUrl = API_URL;
    const [items, setItems]=useState('');
    const getParam = useParams();
    const getjobid = getParam.jobid;
    const [successMessages, setSuccessMessages] = useState([]);
    const [comm,setComm]=useState('');
    const [knowledge,setKnowledge]=useState('');
    const [transparency,setTransparency]=useState('');
    const [cleanliness,setCleanliness]=useState('');
    const [professionalism,setProfessionalism]=useState('');
    const [commtwo,setCommtwo]=useState('');
    const [knowledgetwo,setKnowledgetwo]=useState('');
    const [transparencytwo,setTransparencytwo]=useState('');
    const [cleanlinesstwo,setCleanlinesstwo]=useState('');
    const [professionalismtwo,setProfessionalismtwo]=useState('');
    const [values, setValues] = useState('');
    const [itemstwo, setItemstwo] = useState('');
    const [creator, setCreator]=useState('');
    const [foruserId, setForuserId]=useState('');
    const [byuserId, setByuserId]=useState('');
    const [feedbackList, setFeedbackList]=useState([]);
    const [feedbacklisttwo, setFeedbacklisttwo]=useState([]);
    const [industries, setIndustries] = useState([]);

    useEffect(()=>{
        const getjob = async (e) => {
            try{
                const postData = {
                    jobid: getjobid
                };
                const result = await fetch(`${apiUrl}/admin/viewjob`,{
                    method: "POST",
                    headers:{
                        "Content-Type":"application/json",
                        "Accept":"application/json"
                    },
                    body:JSON.stringify(postData)
                });
                const data = await result.json();
                if(data.status !== 200){
                    throw new Error('Data not found');
                }
                setItems(data.data[0].feedback);
                setCreator(data.data[0].user_id)
                setForuserId(data.data[0].for_user_id)
                setByuserId(data.data[0].by_user_id)
                if(data.data.length>=2){
                    setItemstwo(data.data[1].feedback);
                    setCommtwo(data.data[1].communication);
                    setKnowledgetwo(data.data[1].knowledge);
                    setTransparencytwo(data.data[1].transparency);
                    setCleanlinesstwo(data.data[1].cleanliness);
                    setProfessionalismtwo(data.data[1].professionalism);  
                }   
                setComm(data.data[0].communication);
                setKnowledge(data.data[0].knowledge);
                setTransparency(data.data[0].transparency);
                setCleanliness(data.data[0].cleanliness);
                setProfessionalism(data.data[0].professionalism);       
                setValues(data.value);
                setFeedbackList(data.feedbacklist);
                setFeedbacklisttwo(data.feedbacklist);
            }
            catch(error){
                console.error('Error ', error)
            }
        };
        getjob();
    }, []);

    if (items === null) {
        const changeitems = ''
        setItems(changeitems)
    }
    if (itemstwo === null) {
        const changeitemstow = ''
        setItemstwo(changeitemstow)
    }
    if((creator) === (byuserId)){
        // communication
        var Crcommunication = <select className="form-select col-sm-3 selectBox mt-2" value={comm} onChange={(e)=>setComm(e.target.value)}>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                              </select>
        var Prcommunication = <select className="form-select col-sm-3 selectBox mt-2" value={commtwo} onChange={(e)=>setCommtwo(e.target.value)}>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                </select>     
        // Knowledge
        var Crknowledge = <select className="form-select col-sm-3 selectBox mt-2" value={knowledge} onChange={(e)=>setKnowledge(e.target.value)}>
                                {/* <option >{knowledge}</option> */}
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                            </select>
        var Prknowledge = <select className="form-select col-sm-3 selectBox mt-2" value={knowledgetwo} onChange={(e)=>setKnowledgetwo(e.target.value)}>
                            {/* <option value={knowledgetwo}>{knowledgetwo}</option> */}
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                        </select> 
        // Transparency
        var Crtransparency = <select className="form-select col-sm-3 selectBox mt-2" value={transparency} onChange={(e)=>setTransparency(e.target.value)}>
                                {/* <option value={transparency}>{transparency}</option> */}
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                            </select>
        var Prtransparency = <select className="form-select col-sm-3 selectBox mt-2" value={transparencytwo} onChange={(e)=>setTransparencytwo(e.target.value)}>
                                {/* <option value={transparencytwo}>{transparencytwo}</option> */}
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                            </select> 
        // Cleanliness
        var Crcleanliness = <select className="form-select col-sm-3 selectBox mt-2" value={cleanliness} onChange={(e)=>setCleanliness(e.target.value)}>
                                {/* <option value={cleanliness}>{cleanliness}</option> */}
                                <option value="1">1</option>
                                <option value="2">2</option> 
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                            </select>
        var Prcleanliness = <select className="form-select col-sm-3 selectBox mt-2" value={cleanlinesstwo} onChange={(e)=>setCleanlinesstwo(e.target.value)}>
                                {/* <option value={cleanlinesstwo}>{cleanlinesstwo}</option> */}
                                <option value="1">1</option>
                                <option value="2">2</option> 
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                            </select> 
        //  Professionlism
        var Crprofessionalism = <select className="form-select col-sm-3 selectBox mt-2" value={professionalism} onChange={(e)=>setProfessionalism(e.target.value)}>
                                    {/* <option value={professionalism}>{professionalism}</option> */}
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                </select>
        var Prprofessionalism = <select className="form-select col-sm-3 selectBox mt-2" value={professionalismtwo} onChange={(e)=>setProfessionalismtwo(e.target.value)}>
                                    {/* <option value={professionalism}>{professionalism}</option> */}
                                    <option value="1">1</option> 
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                </select>                        
        var creatorfinal =  <select className="form-select col-sm-5 selectBox mt-2" value={items} onChange={(e)=>setItems(e.target.value)}>
                                {feedbackList.map((feedbackitems)=>{
                                    return(<option value={feedbackitems.text}>{feedbackitems.text}</option>)
                                })}
                            </select>
        // <span>{items}</span>             
        var providerfinal =  <select className="form-select col-sm-5 selectBox mt-2" value={itemstwo} onChange={(e)=>setItemstwo(e.target.value)}>
                                {feedbacklisttwo.map((feedbackitems)=>{
                                    return(<option value={feedbackitems.text}>{feedbackitems.text}</option>)
                                })}
                            </select>
        // <span>{itemstwo}</span>                    
      }
      else{
        // data
        var Prcommunication = <select className="form-select col-sm-3 selectBox mt-2" value={comm} onChange={(e)=>setComm(e.target.value)}>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                            </select>
        var Crcommunication  = <select className="form-select col-sm-3 selectBox mt-2" value={commtwo} onChange={(e)=>setCommtwo(e.target.value)}>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                </select>     
        // Knowledge
        var Prknowledge  = <select className="form-select col-sm-3 selectBox mt-2" value={knowledge} onChange={(e)=>setKnowledge(e.target.value)}>
                                {/* <option >{knowledge}</option> */}
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                            </select>
        var Crknowledge = <select className="form-select col-sm-3 selectBox mt-2" value={knowledgetwo} onChange={(e)=>setKnowledgetwo(e.target.value)}>
                            {/* <option value={knowledgetwo}>{knowledgetwo}</option> */}
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                        </select> 
        // Transparency
        var Prtransparency  = <select className="form-select col-sm-3 selectBox mt-2" value={transparency} onChange={(e)=>setTransparency(e.target.value)}>
                                {/* <option value={transparency}>{transparency}</option> */}
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                            </select>
        var Crtransparency = <select className="form-select col-sm-3 selectBox mt-2" value={transparencytwo} onChange={(e)=>setTransparencytwo(e.target.value)}>
                                {/* <option value={transparencytwo}>{transparencytwo}</option> */}
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                            </select> 
        // Cleanliness
        var Prcleanliness  = <select className="form-select col-sm-3 selectBox mt-2" value={cleanliness} onChange={(e)=>setCleanliness(e.target.value)}>
                                {/* <option value={cleanliness}>{cleanliness}</option> */}
                                <option value="1">1</option>
                                <option value="2">2</option> 
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                            </select>
        var Crcleanliness = <select className="form-select col-sm-3 selectBox mt-2" value={cleanlinesstwo} onChange={(e)=>setCleanlinesstwo(e.target.value)}>
                                {/* <option value={cleanlinesstwo}>{cleanlinesstwo}</option> */}
                                <option value="1">1</option>
                                <option value="2">2</option> 
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                            </select> 
        //  Professionlism
        var Prprofessionalism = <select className="form-select col-sm-3 selectBox mt-2" value={professionalism} onChange={(e)=>setProfessionalism(e.target.value)}>
                                    <option value="1">1</option>
                                    <option value="2">2</option> 
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                </select>
        var Crprofessionalism  = <select className="form-select col-sm-3 selectBox mt-2" value={professionalismtwo} onChange={(e)=>setProfessionalismtwo(e.target.value)}>
                                    <option value="1">1</option>
                                    <option value="2">2</option> 
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                </select>  
        // data
        var providerfinal =  <select className="form-select col-sm-5 selectBox mt-2" value={items} onChange={(e)=>setItems(e.target.value)}>
                                {feedbackList.map((feedbackitems)=>{
                                    return(<option value={feedbackitems.text}>{feedbackitems.text}</option>)
                                })}
                            </select>         
        var creatorfinal =  <select className="form-select col-sm-5 selectBox mt-2" value={itemstwo} onChange={(e)=>setItemstwo(e.target.value)}>
                                {feedbacklisttwo.map((feedbackitems)=>{
                                    return(<option value={feedbackitems.text}>{feedbackitems.text}</option>)
                                })}
                            </select>
        // providerfinal =  <span>{items}</span>   
        //  =  <span>{itemstwo}</span>                  
      }

      const updatejob = async(e) =>{
        if((creator) === (byuserId)){
            var crcommunication = comm
            var crknowledge = knowledge
            var crtransparency = transparency
            var crcleanliness = cleanliness
            var crprofessionalism = professionalism
            var prcommunication = commtwo
            var prknowledge = knowledgetwo
            var prtransparency = transparencytwo
            var prcleanliness = cleanlinesstwo
            var prprofessionalism = professionalismtwo
            var job_creator = creator
            var for_userid = foruserId
            var by_userid = byuserId
            creatorfinal =  items
            providerfinal =  itemstwo
        }else{
            crcommunication = commtwo
            crknowledge = knowledgetwo
            crtransparency = transparencytwo
            crcleanliness = cleanlinesstwo
            crprofessionalism = professionalismtwo
            prcommunication = comm
            prknowledge = knowledge
            prtransparency = transparency
            prcleanliness = cleanliness
            prprofessionalism = professionalism
            job_creator = creator
            for_userid = byuserId
            by_userid = foruserId
            providerfinal =  items    
            creatorfinal =  itemstwo
        }
        
        e.preventDefault();
        try{
            const postData={
                "job_id":getjobid,
                "job_creator":job_creator,
                "for_userid":for_userid,
                "by_userid":by_userid,
                "crcommunication":crcommunication,
                "crknowledge":crknowledge,
                "crtransparency":crtransparency,
                "crcleanliness":crcleanliness,
                "crprofessionalism":crprofessionalism,
                "prcommunication":prcommunication,
                "prknowledge":prknowledge,
                "prtransparency":prtransparency,
                "prcleanliness":prcleanliness,
                "prprofessionalism":prprofessionalism,
                "providerfinal" : providerfinal,        
                "creatorfinal" :  creatorfinal
            }
            const result = await fetch(`${apiUrl}/admin/adminupdatejob`,{
                method: "POST",
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body:JSON.stringify(postData) 
            });
            const data = await result.json();
            if((data.status === 200)){
                const newSuccessMessage = data.message;
                setSuccessMessages([...successMessages, newSuccessMessage]);
            }else if((data.status === 400)){
                const newSuccessMessage = data.message;
                setSuccessMessages([...successMessages, newSuccessMessage]);
            }
            if(data.status !== 200){
                throw new Error('Data not found');
            }
            setItems(data.data);
        }
        catch(error){
            console.log('Error: ', error)
        }
    }

    const handleSuccessMessageFadeOut = () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
        window.location.reload();
    }
    return (
        <div className='width90'>
            <h2 className='pageTitle'>Edit Job Feedback</h2>
            <div className='commonCntr'>
                <form className="form-horizontal" onSubmit={updatejob}>
                    {/* <div className="form-group">
                        <label className="control-label col-sm-2 label" htmlFor="jobtitle">Job Title:</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" id="jobtitle" value="" onChange={(e)=>setItems(e.target.value)}  />
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label" htmlFor="jobdesc">Job Description:</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" id="jobdesc" value="" onChange={(e)=>setItems(e.target.value)}  />
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label" htmlFor="jobcreator">Job Creator:</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" id="jobcreator" value="" onChange={(e)=>setItems(e.target.value)}  />
                        </div>
                    </div>
                    <div className="form-group mt-4"> 
                        <label className="control-label col-sm-2 label" htmlFor="jobassigned">Job Assigned to:</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" id="jobassigned" value="" onChange={(e)=>setItems(e.target.value)}  />
                        </div>
                    </div> */}
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-4 label">Job creator:</label>
                        <div className="col-sm-10 mt-1">
                            <span className='d-block'>{values['creator']}</span>
                            <span className='d-block'>{values['creatorEmail']}</span>
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Job Reviews</label>
                        <div className="col-sm-4 mt-1">
                            <span className='display-block mt-2'>Communication</span>
                            {Crcommunication}
                            <span className='display-block mt-2'>Knowledge</span>
                            {Crknowledge}
                            <span className='display-block mt-2'>Transparency</span>
                            {Crtransparency}
                            <span className='display-block mt-2'>Cleanliness</span>
                            {Crcleanliness}
                            <span className='display-block mt-2'>Professionalism</span>
                            {Crprofessionalism}
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label" htmlFor="feedback">Final Feedback</label>
                        <div className="col-sm-11">
                            {creatorfinal}
                            {/* <input type="text" className="form-control" id="feedback" value={items.feedback}   /> */}
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Job Assigned to:</label>
                        <div className="col-sm-10 mt-1">
                            <span className='d-block'>{values['provider']}</span>
                            <span className='d-block'>{values['providerEmail']}</span>
                        </div>
                    </div>
                    <div className="col-sm-4 mt-4">
                        <label className="control-label col-sm-4 label">Job Reviews</label>
                        <span className='display-block mt-2'>Communication</span>
                        {Prcommunication}
                        <span className='display-block mt-2'>Knowledge</span>
                        {Prknowledge}
                        <span className='display-block mt-2'>Transparency</span>
                        {Prtransparency}
                        <span className='display-block mt-2'>Cleanliness</span>
                        {Prcleanliness}
                        <span className='display-block mt-2'>Professionalism</span>
                        {Prprofessionalism}
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label" htmlFor="feedback">Final Feedback</label>
                        <div className="col-sm-11">
                            {providerfinal}
                            {/* <input type="text" className="form-control" id="feedback" value={items.feedback}   /> */}
                        </div>
                    </div>
                    <div className="form-group mt-4 mb-4">
                        <div className="col-sm-offset-2 col-sm-10">
                            <button type="submit" className="btn btn-default submitBtn">Submit</button>
                        </div>
                    </div>
                </form>
                {
                    successMessages.map((message, index) => (
                        <SuccessMessage
                            key={index} 
                            message = {message} 
                            onFadeOut={handleSuccessMessageFadeOut}
                        />
                    )
                )}
            </div>
        </div>
    )
}

export default Editjob;